import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Location } from '@angular/common';
import { VhViethasWebAPPEndUser } from 'vhwebapp';
import * as DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { WebappSeemoreDialogC001UserComponent } from './webapp-seemore-dialog-c001-user/webapp-seemore-dialog-c001-user.component';
import { WebappTechniqueDialogC001UserComponent } from './webapp-technique-dialog-c001-user/webapp-technique-dialog-c001-user.component';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-webapp-detail-product-c001-user',
  templateUrl: './webapp-detail-product-c001-user.component.html',
  styleUrls: ['./webapp-detail-product-c001-user.component.scss']
})
export class WebappDetailProductC001UserComponent implements OnInit {
  public routeParams: any
  public listProduct: any
  public nameProduct: string; /// tên sản phẩm được chọn
  public itemProduct: any; /// sản phẩm đã lọc từ danh sách json và data
  public itemProductThisPage: any; /// sản phẩm được lọc từ data tại component
  public id_active: number = 1;
  public path_imageAcitve: string = '';
  public previousUrl: string = '/product-list/toa-device';
  public isMobile: boolean;
  public id_product: string;
  arr_img = []
  data: any;
  id_category: any;
  isLoading: boolean = false;
  public EDITOR = DecoupledEditor;
  config: any = {
    ckfinder: {
      options: {
        language: 'en',
        resourceType: 'Images',
        readonly: true,
      },
    },
  };
  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public platform: Platform,
    public location: Location,
    private router: Router,
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser,
    public titleService: Title,
    public metaTagService: Meta,
  ) {
    if (this.platform.is('desktop')) this.isMobile = false;
    else this.isMobile = true;
  }

  ngOnInit(): void {
    this.getData();
  }

  setFavicon(favIcon_img) {
    let favIcon: HTMLLinkElement = document.querySelector('#appIcon');
    console.log(favIcon)
    favIcon.href = favIcon_img;
    this.metaTagService.addTags([
      { property: 'og:image', itemprop: 'thumbnailUrl', content: favIcon_img },
    ]);
  }

  public onReady(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
  }
  formatInitName(_value) {
    return _value.split('-').join(' ')
  }

  getData() {
    this.isLoading = true
    this.route.params.subscribe((routeParams) => {
      this.routeParams = routeParams
      console.log(this.routeParams)
      this.vhViethasWebAPPEndUser.getComponentContent('webapp_fields_c001_items',routeParams.id_product)
        .then((response: any) => {
          console.log(response)
          if (response.vcode === 0 && response.data) {
            this.isLoading = false
            //-----------your code-----------
            this.listProduct = response.data;
            this.id_category = this.listProduct.id_webapp_fields_c001_category
            this.arr_img = [
              {
                id: 1,
                path: this.listProduct.webapp_products_img
              },
              {
                id: 2,
                path: this.listProduct.webapp_products_img1
              },
              {
                id: 3,
                path: this.listProduct.webapp_products_img2
              },
              {
                id: 4,
                path: this.listProduct.webapp_products_img3
              }
            ];
            this.path_imageAcitve = this.arr_img[0].path;
            this.titleService.setTitle(this.listProduct.name + ' ' + '- Viethas cung cấp tất cả thiết bị bán hàng chuyên dụng');
            this.metaTagService.updateTag({ name: 'description', content: this.listProduct.webapp_products_seo_keyword },)
            this.setFavicon(this.listProduct.webapp_products_img)
          
          }
        }, error => {
          this.isLoading = false
          console.log('error', error)
        })
    });
  }

  changeImage(_id, _path): void {
    this.id_active = _id;
    this.path_imageAcitve = _path;
  }
  isNumber(val): boolean {
    return typeof val === 'number';
  }
  /**Hàm kiểm tra có khuyến mãi
   *
   * @param _value
   * @return true false
   */
  checkDiscount(_value): boolean {
    if (_value) {
      return true;
    } else {
      return false;
    }
  }
  /** Hàm tính số tiền còn lại khi đã khuyến mãi
   *
   *
   * @param _price
   * @param _discount
   * @return number
   */
  sum(_price, _discount): number {
    let discounted = (_discount / _price) * 100;
    return Math.round(100 - discounted);
  }
  openDialog(_value): void {
    let width = this.platform.is('desktop') ? '40%' : '100%';
    const dialogRef = this.dialog.open(WebappTechniqueDialogC001UserComponent, {
      width: width,
      maxWidth: '100%',
      maxHeight: '100%',
      data: {
        content: _value,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
    });
  }
  goBack(): void {
    this.location.back();
  }
  /** Kiểm tra dữ liệu có tồn tại trong mảng
   *
   * @param Arr
   * @param _nameProduct
   * @returns
   */
  checkExist(Arr: any[], _nameProduct): boolean {
    for (let i = 0; i <= Arr.length; i++) {
      if (Arr[i].name_product == _nameProduct) {
        return true;
      }
    }
    return false;
  }

  chooseImage(_id, _path): void {
    this.id_active = _id;
    this.path_imageAcitve = _path;
  }
  /** Chuyyển page trước
   *
   */
  previusFn(): void {
    if (this.id_active == 1) {
      this.path_imageAcitve =
        this.arr_img[1].path;
      this.id_active = 1
    } else {
      this.id_active = this.id_active - 1
      this.path_imageAcitve =
        this.arr_img[this.id_active].path;
    }
  }
  /** Chuyyển page kế
   *
   */
  nextFn(): void {
    if (this.id_active == this.arr_img.length) {
      this.path_imageAcitve =
        this.arr_img[this.id_active].path;
      this.id_active = this.arr_img.length
    } else {
      this.id_active = this.id_active + 1
      this.path_imageAcitve =
        this.arr_img[this.id_active].path;
    }
  }
  /** Xem mô tả chi tiết
   *
   * @param data      // mảng dữ liệu mô tả sản phẩm
   */
  openDetail(data): void {
    let width = this.platform.is('desktop') ? '40%' : '100%';
    const dialogRef = this.dialog.open(WebappSeemoreDialogC001UserComponent, {
      width: width,
      maxWidth: '100%',
      data: data
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
    });
  }

}
